import React from 'react';

export const AbSelectionField = ({ workflowGraph, onChange, selectedBranch, label }) => {
  if (workflowGraph?.hasAbTest) {
    const abNode = workflowGraph.getNode(workflowGraph.abNodeId);
    return (
      <div>
        <div>{label}</div>
        {abNode.parameters.allocations.map(branch => {
          return (
            <div>
              <input
                type="radio"
                id={branch.name}
                checked={selectedBranch === branch.name}
                name={branch.name}
                value={branch.name}
                onChange={() => onChange(branch.name)}
              />{' '}
              <label for={branch.name}>{branch.name}</label>
            </div>
          );
        })}
      </div>
    );
  }
  return null;
};
